module.exports = __webpack_public_path__ + "img/info-toaster.aed5dab.svg";